import {GameAction, GameActionEnum, GameState} from "./types";
import {ICpuData} from "../../../models/game/ICpuData";


const initialState: GameState = {
    activeCpu: null,

    game: null,
    gamePvPData: null,
    phase: null,
    playerFire: {inc: 0, amount: 0},
    playerDiamond: {inc: 0, amount: 0},
    playerPow: {inc: 0, amount: 0},
    playerHp: 0,
    playerHand: [],
    playerTable: {0: null, 1: null, 2: null, 3: null, 4: null},
    playerAD: {0: false, 1: false, 2: false, 3: false, 4: false},

    playerTurn: 0,
    playerMulligan: false,

    cpuData: {} as ICpuData,

    cpuFire: {inc: 0, amount: 0},
    cpuDiamond: {inc: 0, amount: 0},
    cpuPow: {inc: 0, amount: 0},
    cpuHp: 0,
    cpuTable: {0: null, 1: null, 2: null, 3: null, 4: null},
    playedCard: {card: null, handKey: null, target: null},
    cpuPlayedCard: {card: null, target: null},

    counters: {player: {deck_count: 0, hand_count: 0}, cpu: {deck_count: 0, hand_count: 0}},

    endGame: {winner: null, result: null},

    message: {text: null, type: null, delay: null},
    isPvP: false,
    isPlaySpellDrag: false,
    touchDragCoords: {},
    battleBg: "defaultBG",
    isLoading: false,
}

export default function authReducer(state = initialState, action: GameAction): GameState {
    switch (action.type) {
        case GameActionEnum.SET_IS_BATTLE_LOADING:
            return {...state, isLoading: action.payload};
        case GameActionEnum.SET_BATTLE_BG:
            return {...state, battleBg: action.payload}
        case GameActionEnum.SET_IS_PVP:
            return {...state, isPvP: action.payload}
        case GameActionEnum.SET_CPU:
            return {...state, activeCpu: action.payload}
        case GameActionEnum.SET_CPU_DATA:
            return {...state, cpuData: action.payload}
        case GameActionEnum.SET_GAME:
            return {...state, game: action.payload}
        case GameActionEnum.SET_GAME_PVP_DATA:
            return {...state, gamePvPData: action.payload}
        case GameActionEnum.SET_PHASE:
            return {...state, phase: action.payload}
        case GameActionEnum.SET_PLAYER_FIRE:
            return {...state, playerFire: action.payload}
        case GameActionEnum.SET_PLAYER_DIAMOND:
            return {...state, playerDiamond: action.payload}
        case GameActionEnum.SET_PLAYER_POW:
            return {...state, playerPow: action.payload}
        case GameActionEnum.SET_PLAYER_HP:
            return {...state, playerHp: action.payload}
        case GameActionEnum.SET_PLAYER_TABLE:
            return {...state, playerTable: action.payload}
        case GameActionEnum.SET_PLAYER_HAND:
            return {...state, playerHand: action.payload}
        case GameActionEnum.SET_CPU_FIRE:
            return {...state, cpuFire: action.payload}
        case GameActionEnum.SET_CPU_DIAMOND:
            return {...state, cpuDiamond: action.payload}
        case GameActionEnum.SET_CPU_POW:
            return {...state, cpuPow: action.payload}
        case GameActionEnum.SET_CPU_TABLE:
            return {...state, cpuTable: action.payload}
        case GameActionEnum.SET_CPU_HP:
            return {...state, cpuHp: action.payload}
        case GameActionEnum.SET_PLAYED_CARD:
            return {...state, playedCard: action.payload}
        case GameActionEnum.SET_CPU_PLAYED_CARD:
            return {...state, cpuPlayedCard: action.payload}
        case GameActionEnum.SET_PLAYER_AD:
            return {...state, playerAD: action.payload}
        case GameActionEnum.SET_END_GAME:
            return {...state, endGame: action.payload}
        case GameActionEnum.SET_MESSAGE:
            return {...state, message: action.payload}
        case GameActionEnum.SET_COUNTERS:
            return {...state, counters: action.payload}
        case GameActionEnum.SET_IS_PLAY_SPELL_DRAG:
            return {...state, isPlaySpellDrag: action.payload}
        case GameActionEnum.SET_TOUCH_DRAG_COORDS:
            return {...state, touchDragCoords: action.payload}
        case GameActionEnum.SET_PLAYER_MULLIGAN:
            return {...state, playerMulligan: action.payload}
        case GameActionEnum.SET_PLAYER_TURN:
            return {...state, playerTurn: action.payload}
        default:
            return state;
    }
}
